<script setup lang="ts">
const items = [
  {
    title: 'Daftar Akun KiriminAja'
  },
  {
    title: 'Hubungkan WhatsApp Bisnismu'
  },
  {
    title: 'Atur Pesan Otomatis (Reminder, Promo, Ucapan)'
  }
]
</script>

<template>
  <div
    class="bg-surface-container-low dark:bg-surface-container py-7 lg:py-16 relative overflow-hidden"
  >
    <UiBgSkewY />
    <UiContainer class="flex flex-col gap-11 relative z-10">
      <UiSectionTitle class="text-center" title="3 Langkah Mudah Mulai ROMS" />
      <UiCarouselFeature :items="items" />
    </UiContainer>
  </div>
</template>
